/**
 * WineNot — Botón flotante de WhatsApp
 *
 * INSTALACIÓN:
 * 1. Assets → nuevo archivo → winenot-whatsapp.js
 * 2. En theme.liquid antes de </body>:
 *    {{ 'winenot-whatsapp.js' | asset_url | script_tag }}
 */

(function () {

  if (window.Shopify && window.Shopify.designMode) return;

  // Número de WhatsApp (sin espacios ni guiones)
  var WA_NUMBER = '5491131840010';
  var WA_MESSAGE = '¡Hola! Quisiera consultar sobre los vinos de WineNot.';

  var style = document.createElement('style');
  style.textContent = `
    #wn-whatsapp {
      position: fixed;
      bottom: 24px;
      right: 24px;
      z-index: 9999;
      display: flex;
      align-items: center;
      gap: 10px;
      cursor: pointer;
      text-decoration: none;
    }

    #wn-whatsapp-bubble {
      background: #25D366;
      border-radius: 50%;
      width: 56px;
      height: 56px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 4px 16px rgba(37, 211, 102, 0.35);
      transition: transform 0.2s, box-shadow 0.2s;
      flex-shrink: 0;
    }

    #wn-whatsapp:hover #wn-whatsapp-bubble {
      transform: scale(1.08);
      box-shadow: 0 6px 20px rgba(37, 211, 102, 0.5);
    }

    #wn-whatsapp-bubble svg {
      width: 30px;
      height: 30px;
      fill: #fff;
    }

    #wn-whatsapp-label {
      background: #3a2c31;
      color: #f5f0ea;
      font-family: 'Poppins', sans-serif;
      font-size: 13px;
      font-weight: 500;
      padding: 8px 14px;
      border-radius: 20px;
      box-shadow: 0 2px 10px rgba(0,0,0,0.2);
      white-space: nowrap;
      opacity: 0;
      transform: translateX(10px);
      transition: opacity 0.2s, transform 0.2s;
      pointer-events: none;
    }

    #wn-whatsapp:hover #wn-whatsapp-label {
      opacity: 1;
      transform: translateX(0);
    }

    @media (max-width: 640px) {
      #wn-whatsapp-label { display: none; }
      #wn-whatsapp { bottom: 16px; right: 16px; }
    }
  `;
  document.head.appendChild(style);

  var link = document.createElement('a');
  link.id = 'wn-whatsapp';
  link.href = 'https://wa.me/' + WA_NUMBER + '?text=' + encodeURIComponent(WA_MESSAGE);
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  link.setAttribute('aria-label', 'Contactar por WhatsApp');

  link.innerHTML = `
    <span id="wn-whatsapp-label">¿Consultas? Escribinos</span>
    <div id="wn-whatsapp-bubble">
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
      </svg>
    </div>
  `;

  document.body.appendChild(link);

})();